import { Button, TextField } from "@material-ui/core";
import Card from "@mui/material//Card";
import CardContent from "@mui/material//CardContent";
import CardMedia from "@mui/material//CardMedia";
import Typography from "@mui/material/Typography";
import Box from "@mui/material//Box";
import cx from 'clsx';
import { makeStyles } from "@material-ui/core/styles";
import { useBouncyShadowStyles } from '@mui-treasury/styles/shadow/bouncy';
import { useState } from "react";
import { login } from "../../Actions/userActions";
import { connect } from "react-redux";
import { Redirect } from "react-router";

const initialFormValues = { username: "Test1", password: "abc123" };

export const Login = ({ login }) => {
	const [formValues, setFormValues] = useState(initialFormValues);
	const [loggedIn, setLoggedIn] = useState(false);

	const onSubmit = async (e) => {
		e.preventDefault();
		await login(formValues);
		setFormValues(initialFormValues);
		setLoggedIn(true);
	};

	const onChange = (e) => {
		setFormValues({ ...formValues, [e.target.name]: e.target.value });
	};
		
	const bullet = (
		<Box
			component="span"
			sx={{ display: 'inline-block', mx: '2px', transform: 'scale(1.2)' }}
		>
			~
		</Box>
	);

	const landingCard = (
		<>
			<CardContent>
				<Typography variant="h3" component="h2">
					Welcome to Secret Recipes!
				</Typography><br />
				<CardMedia
					component="img"
					height="200"
					image="https://images.unsplash.com/photo-1512621776951-a57141f2eefd?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1170&q=80"
					alt="food on a table"
				/><br />
				<Typography sx={{ fontSize: 16 }} color="text.primary">
					Do you have family recipes or favorite dinner go-to recipes stashed away on old notecards or notebooks? 
				</Typography><br />
				<Typography sx={{ fontSize: 21, fontWeight: 'bold'}} color="text.secondary" gutterBottom>
					{bullet} You're in luck! {bullet}
				</Typography><br />
				<Typography sx={{ fontSize: 16 }} color="text.primary">	
					With this Secret Recipe App, you can now save all of your recipes in one location.
				</Typography><br />
				<Typography sx={{ fontSize: 16 }} color="text.primary">
					Save a picture of the recipe, too! You'll be able to add a recipe source. 
				</Typography>
				<Typography sx={{ fontSize: 16 }} color="text.secondary">	
					(whether it's from Grandma or from an online recipe website)
				</Typography><br /> 
				<Typography sx={{ fontSize: 16 }} color="text.primary">	
					You can also add an ingredients list and recipe instructions!
				</Typography><br />
				<Typography sx={{ fontSize: 16, fontWeight: 'bold', fontStyle: 'oblique' }} color="text.secondary">	
					Coming soon on future updates:
				</Typography><br />
				<Typography sx={{ fontSize: 16 }} color="text.secondary">	
					* Share recipes with family and friends
				</Typography>
				<Typography sx={{ fontSize: 16 }} color="text.secondary">	
					* Add multiple recipe photos
				</Typography>
				<Typography sx={{ fontSize: 16 }} color="text.secondary">	
					* And much more!
				</Typography><br />
			</CardContent>
		</>
	);

	const styles = makeStyles(() => ({
		root: {
			maxWidth: 304,
			margin: 'auto',
			boxShadow: 'none',
			borderRadius: 0,
		},
		content: {
			padding: 24,
		},
		cta: {
			marginTop: 24,
			textTransform: 'initial',
		},
	}));

	const shadowStyles = useBouncyShadowStyles();

	if (loggedIn) {
		return <Redirect to="/recipebook" />;
	} else {
		return (
			<><br/>
				<div className="login-container">
					<Box>
						<Card variant="outlined" className={cx(styles.root, shadowStyles.root)}><br />
							<form onSubmit={onSubmit}>
								<TextField
									id="username-input"
									name="username"
									label="Username"
									type="text"
									value={formValues.username}
									onChange={onChange}
								></TextField>
								<TextField
									id="password-input"
									name="password"
									label="Password"
									type="password"
									value={formValues.password}
									onChange={onChange}
								></TextField>
								<Button
									variant="contained"
									color="primary"
									size="large"
									className="button"
									onClick={onSubmit}
								>
									Login
								</Button>
							</form><br />
						</Card>
					</Box>
					<Box mt={1} mb={1} >
						<Card variant="outlined" className={cx(styles.root, shadowStyles.root)}>
							<CardContent>
								<Typography sx={{ fontSize: 12 }} color="text.secondary" gutterBottom>
									Don't have an account? <a href="/createaccount"> Create an Account</a>{" "}
									and start your recipe book today!
								</Typography>
							</CardContent>
						</Card>
					</Box>
					<Box mt={2} sx={{ minWidth: 275, maxWidth: 675 }}>
						<Card variant="outlined" className={cx(styles.root, shadowStyles.root)}>{landingCard}</Card>
					</Box>
				</div>
			</>
		);
	}
};
export default connect(null, { login })(Login);
